export enum ETipoNotificacao {
    Normal = 1,
    Importante = 2,
    Urgente = 3
}
